import React, { FunctionComponent, useContext, useEffect } from 'react';
import { FullScreenWrapper } from 'components/Layouts/FullScreenView/FullScreenWrapper';
import { useAppSelector } from 'hooks/redux';
import { FullScreenContent } from 'components/Layouts/FullScreenView/FullScreenContent';
import { FullScreenDetails } from 'components/Layouts/FullScreenView/FullScreenDetails';
import { SquareImage } from 'components/Images/SquareImage';
import { FullScreenTitle } from 'components/Layouts/FullScreenView/FullScreenTitle';
import { PageAnimationOpacity } from 'components/LayoutAnimations/PageAnimationOpacity';
import { UserAgentContext } from 'features/user-agent/userAgent';
import { useNavigate } from 'react-router-dom';
import { usePageLoaded } from 'hooks/usePageLoaded';
import { Loader } from 'components/Loader';
import { useOnceEffect } from 'hooks/useOnceEffect';
import { Mixpanel } from 'utilities/mixpanel';
import { PrivacyNotice } from 'features/privacy/privacyNotice';

export const InstantEvent: FunctionComponent = () => {
  const channelDetails = useAppSelector(
    (state) => state.channel.channelDetails
  );
  const { isCreatorAppWebview, isDACreatorAppVersion } =
    useContext(UserAgentContext);
  const navigate = useNavigate();
  const isSingleDAView = isDACreatorAppVersion(
    `${process.env.REACT_APP_DA_SINGLE_VIEW_MIN_VERSION}`
  );

  usePageLoaded();

  useEffect(
    function show404NonDACreatorApp() {
      if (channelDetails && !isCreatorAppWebview) {
        navigate('../404');
      }
    },
    [isCreatorAppWebview, navigate, channelDetails]
  );

  useOnceEffect(function mixpanelPageViewForDA() {
    if (channelDetails && channelDetails?.ownerId) {
      Mixpanel.identify(channelDetails.ownerId);
      Mixpanel.track('Page Viewed');
    }
  }, isSingleDAView && channelDetails);

  const renderTitle = () => {
    if (channelDetails?.defaultEventConfiguration?.title) {
      return channelDetails.defaultEventConfiguration.title;
    }
    return `${channelDetails?.username}'s live event`;
  };

  if (!channelDetails) {
    return <Loader fillComponent={true} hideOnNative={true} />;
  }

  return (
    <PageAnimationOpacity>
      <FullScreenWrapper
        artwork={channelDetails?.channelArtwork}
        type={'event'}
        color={channelDetails?.themeColor}
      >
        <FullScreenContent
          centerColumn={
            <FullScreenDetails
              image={
                <SquareImage
                  artworkUrl={
                    channelDetails?.channelArtwork.image.large || null
                  }
                  cssClasses={'tw-shadow-glow'}
                />
              }
              liveStatus={<PrivacyNotice />}
              meta={
                <div className="tw-text-center tw-mx-auto tw-max-w-[620px] tw-full">
                  <>
                    Click <strong>Start</strong> to go live with...
                    <FullScreenTitle title={renderTitle()} />
                  </>
                </div>
              }
            />
          }
        />
      </FullScreenWrapper>
    </PageAnimationOpacity>
  );
};
